<mat-card class="p-0">
  <mat-card-title>
    <div class="card-title-text">
      
    </div>
  </mat-card-title>
  <mat-card-content>
    Vuoi eliminare il nominativo {{data.row.Cognome}} {{data.row.Nome}} ?

          <div mat-dialog-actions>
            <button mat-raised-button color="primary"
                    (click)="btnAnnulla()">
              Annulla
            </button>
            <button mat-raised-button color="primary"
                    (click)="btnSalva()"
                    cdkFocusInitial>
              Elimina
            </button>
          </div>
  </mat-card-content>
</mat-card>
<style>

  .inserimento-form {
    min-width: 150px;
    max-width: 720px !important;
    width: 100%;
  }

  /* .full-width {
      width: 100%;
    }*/
</style>
